<template>
  <div class="cd-pay-res">
    <y-panel-msg
      :ico="require('@/assets/pay-res-success.png')"
      :title="title"
      :content="content"
    ></y-panel-msg>
    <div class="space"></div>
    <div class="btn">
      <y-button @click="gotoDetail()">查看卡片</y-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaySuccess",
  data() {
    return {
      cardId: "",
      amount: "",
      duration: "",
      expireTime: "", // 卡的过期时间
    };
  },
  created() {
    this.cardId = this.$route.params.id;
    this.amount = parseFloat(this.$route.query.amount) || 0;
    this.duration = parseInt(this.$route.query.duration) || 0;
    let day = parseInt(this.$route.query.day) || 0;

    let now = new Date();
    this.expireTime = new Date(now.setDate(now.getDate() +  day));
  },
  computed:{
    title(){
      return "成功支付 ￥" + this.amount.toFixed(2);
    },
    content(){
      return "已经成功续费" + (this.duration > 9 ? this.duration : "0" + this.duration) + "个月，到期时间为 " + this.expireTime.format("yyyy年MM月dd日");
    }
  },
  methods: {
    gotoDetail() {
      //this.$router.push("/care/" + this.cardId);
      this.$router.push("/care/");
    },
  },
};
</script>

<style lang="less" scope>
.cd-pay-res {
  height: 100vh;
  width: 100vw;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .space {
    flex: 1 1;
  }
  .btn {
    width: 100%;
    margin-bottom: 14px;
  }
}
</style>